import React from 'react'
import './Footer.css'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";


const Footer = () => {
  return <div className="footer-container">
    <div className="footer-left">
      {/* <div className="item help">Need help?</div> */}
      <div className="item"><a href="mailto:TSCHelpDesk@fdny.nyc.gov"><FontAwesomeIcon icon={faEnvelope} size={'lg'} />&nbsp;&nbsp;Email Us</a></div>
      <div className="item"><a href="tel:718-999-2611"><FontAwesomeIcon icon={faPhone} />&nbsp;&nbsp;718-999-2611</a></div>
    </div>

    <div className="footer-right">
      <div className="item"><a href="http://www.nyc.gov/html/fdny/html/home2.shtml">FDNY Intranet</a> &nbsp;&nbsp;|&nbsp;&nbsp; <a href="http://www.nyc.gov/html/fdny/insider/index.shtml">FDNY Insider</a> &nbsp;&nbsp;|&nbsp;&nbsp; <a href="http://www.fdnyfoundation.org/">FDNY Foundation</a> &nbsp;&nbsp;|&nbsp;&nbsp; <a href="http://www1.nyc.gov">NYC.gov</a></div>
      <div className="item"> Copyright &copy; 2022, Fire Department City of New York</div>
    </div>
  </div>
}

export default Footer